module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Dead Travel Fast")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9780312371111.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9780312371111_ch01#ch01"
    }
  }, [_vm._v("I "), _c('br'), _vm._v("MONSTERS WANTED")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author defines his vampire quest, dresses in a stinky mummy costume, watches too many movies, and then throws up.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II "), _c('br'), _vm._v("BERRIES IN A PAIL")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author sets out to find vampires and in the process deconstructs Girls Gone Wild, fights off porn ads, and ponders the evolution off lies.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III "), _c('br'), _vm._v("I DON’T BELIEVE IN GOD; THE CRUCIFIX IS TO KEEP AWAY VAMPIRES")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author travels to the land of the vampire and along the way deals with dog attacks, floods, possible amputation, and running out of hand sanitizer.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV "), _c('br'), _vm._v("PULLING OUT THE FEATHERS FIRST")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As our story continues, the author searches for the hidden meaning of Friends, sees sixteen breasts, and is rocked like a hurricane.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9780312371111_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V "), _c('br'), _vm._v("FROM WAMPYR TO WHITBY")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author travels to England to find exploding graves, great bargains at Top Shop, coffin-shaped candy, and gay men spilling into the streets.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI "), _c('br'), _vm._v("GOD IS DEAD AND NO ONE CARES")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author meets many vampires and two rats, then refuses to dress like a gay pirate.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII "), _c('br'), _vm._v("I MAY BE DEAD, BUT I’M STILL PRETTY")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author sits through 144 episodes of Buffy the Vampire Slayer, sits in the dark with 1,000 people, and cringes a lot.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII "), _c('br'), _vm._v("WELCOME TO DARKWING MANOR")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author concludes his journey celebrating Halloween in Oregon, choking on PoliGrip, and trying not to contract salmonella.")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780312371111_ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In which the author shouts out to his peeps, yo.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a8f1d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312371111_toc.vue
// module id = 75
// module chunks = 0